import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar, FaHeart, FaShoppingCart, FaUser } from 'react-icons/fa';

function PostCard({ post }) {
  const [isFavorite, setIsFavorite] = React.useState(false);
  const [showNotification, setShowNotification] = React.useState(false);

  const handleFavorite = () => {
    setIsFavorite(!isFavorite);
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 2000);
  };

  const handleShare = () => {
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 2000);
  };

  return (
    <article className="post-card semi-transparent">
      <div className="post-card-image">
        <Link to={`/post/${post.id}`}>
          <img src={post.image} alt={post.title} />
        </Link>
      </div>
      <div className="post-card-content">
        <span className="post-card-category">{post.category}</span>
        <h3>{post.title}</h3>
        <div className="post-detail-meta" style={{ marginBottom: '10px', paddingBottom: '10px', fontSize: '0.85rem' }}>
          <span><FaUser /> {post.author}</span>
          <span>{post.date}</span>
          <span><FaStar /> {post.rating}</span>
        </div>
        <p className="post-card-excerpt">{post.excerpt}</p>
        <div className="post-card-actions">
          <Link to={`/post/${post.id}`} className="btn btn-primary">
            <FaShoppingCart /> Olvass tovább
          </Link>
          <button className="btn btn-accent" onClick={handleFavorite}>
            <FaHeart style={{ color: isFavorite ? 'red' : 'inherit' }} /> Kedvenc
          </button>
        </div>
      </div>
      {showNotification && (
        <div className="notification">
          {isFavorite ? 'A bejegyzés hozzáadva a kedvencekhez' : 'A művelet sikeresen megtörtént'}
        </div>
      )}
    </article>
  );
}

export default PostCard;